var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [_c("divider", { attrs: { label: "Dados da portaria" } })],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|max:6" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "N° do D.O.E:", required: true }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { onkeypress: _vm.onlyInputNumbers },
                          model: {
                            value: _vm.numeroPublicacao,
                            callback: function($$v) {
                              _vm.numeroPublicacao = $$v
                            },
                            expression: "numeroPublicacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Data de Publicação:",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { type: "date" },
                          model: {
                            value: _vm.dataPublicacao,
                            callback: function($$v) {
                              _vm.dataPublicacao = $$v
                            },
                            expression: "dataPublicacao"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "container-input", attrs: { span: 12 } },
            [
              _c("app-label", {
                attrs: { label: "Nº da portaria:", required: true }
              }),
              _c("el-input", {
                staticClass: "input",
                attrs: { disabled: "disabled" },
                model: {
                  value: _vm.numeroPortaria,
                  callback: function($$v) {
                    _vm.numeroPortaria = $$v
                  },
                  expression: "numeroPortaria"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37d31a76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d31a76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/DadosPortaria.vue
// module id = null
// module chunks = 